<script setup lang="ts">
import AvatarChecked from '@/assets/icons/Avatars/AvatarChecked.vue';
import { type MessageSchema } from '@/i18n';
import { useUserStore } from '@/stores/useUserStore';
import Button from 'primevue/button';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const router = useRouter();
const userStore = useUserStore();
const isRefreshing = ref(false);

onMounted(async () => {
  // Refresh user data to get the updated subscription
  console.log('[SubscriptionSuccess] Refreshing user data after successful payment');
  isRefreshing.value = true;
  try {
    await userStore.refreshUser();
    console.log('[SubscriptionSuccess] User data refreshed successfully');

    // Automatically acknowledge the subscription change since user is already on success page
    // This prevents the subscription changed dialog from showing on top of the success page
    // if (userStore.showSubscriptionChangedDialog) {
    //   console.log('[SubscriptionSuccess] Auto-acknowledging subscription change');
    //   // await userStore.acknowledgeSubscriptionChange();
    // }
  } catch (error) {
    console.error('[SubscriptionSuccess] Failed to refresh user data:', error);
  } finally {
    isRefreshing.value = false;
  }
});

function goHome() {
  router.push({ path: '/' });
}

function goToSubscriptions() {
  router.push({ path: '/profile/subscriptions' });
}

// Get the current subscription plan name
const currentPlanName = computed(() => {
  return userStore.activeRestaurant?.subscription?.plan?.name || '';
});
</script>

<template>
  <main class="flex flex-col items-center justify-center p-4">
    <div class="mx-auto mb-8 mt-8 flex max-w-lg flex-col items-center justify-center gap-4">
      <!-- Success Icon -->
      <div class="w-24">
        <AvatarChecked />
      </div>

      <!-- Success Message -->
      <h1 class="mb-4 text-center font-bold text-3xl text-gray-800">
        {{ t('common.success') }}
      </h1>

      <p class="mb-6 text-center">
        {{ t('subscription.successfullySubscribed') }}
      </p>

      <!-- Show the plan name if available -->
      <div v-if="currentPlanName && !isRefreshing" class="mb-4 rounded-lg bg-green-50 px-6 py-3 text-center">
        <p class="font-medium text-green-800">
          {{ t('subscription.currentPlan') }}: <span class="font-bold">{{ currentPlanName }}</span>
        </p>
      </div>

      <!-- Loading indicator while refreshing -->
      <div v-if="isRefreshing" class="flex items-center gap-2 text-gray-600">
        <i class="pi pi-spin pi-spinner"></i>
        <span>{{ t('common.loading') }}...</span>
      </div>

      <!-- Navigation Buttons -->
      <div class="flex flex-row flex-wrap items-center justify-center gap-4">
        <Button :label="t('subscription.currentPlan')" icon="pi pi-eye" outlined :disabled="isRefreshing" @click="goToSubscriptions"></Button>
        <Button :label="t('navBar.home')" icon="pi pi-home" :disabled="isRefreshing" @click="goHome"></Button>
      </div>
    </div>
  </main>
</template>
